import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { AuthUser, Utente } from '../../../shared/interface';
import { Table } from 'primeng/table';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { StorageService } from '../../../services/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-utenti-backoffice',
  templateUrl: './utenti-backoffice.component.html',
  styleUrl: './utenti-backoffice.component.css'
})
export class UtentiBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private storageService: StorageService, private confirmationService: ConfirmationService, private router: Router) { }

  @ViewChild("deleteUtente") deleteUtente!: ConfirmPopup;

  utenti: Utente[] = []

  user?: AuthUser | null;

  loading: boolean = false;

  totpDialog = false;
  totpUtente: Utente | null = null;
  totpSetup: { secret: string; qr: string; otpauthUrl: string } | null = null;
  formTotpEnable!: FormGroup;

  ngOnInit(): void {

    this.loading = true;

    this.user = this.storageService.getUser();

    this.formTotpEnable = new FormGroup({
      code: new FormControl(null, [Validators.required, Validators.pattern(/^\d{6}$/)]),
    });

    this.apiService.setUtenti();
    this.apiService.utentiChanged.subscribe({
      next: (data) => {
        this.utenti = [...data.filter(utente => utente.editable || this.user?.user == 'root')];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),      
    })

  }

  isTotpOn(u: Utente) {
    return !!Number(u.totp_enabled);
  }

  openTotp(utente: Utente) {
    this.totpUtente = utente;
    this.totpSetup = null;
    this.formTotpEnable.reset();
    this.totpDialog = true;
  }

  closeTotp() {
    this.totpDialog = false;
    this.totpUtente = null;
    this.totpSetup = null;
    this.formTotpEnable.reset();
  }

  startTotpSetup() {
    if (!this.totpUtente) return;
    this.apiService.setupTotpUtente(this.totpUtente.id).subscribe({
      next: (res) => this.totpSetup = res,
      error: (err) => this.apiService.message('error', 'Errore', err.error?.message?.message || 'Errore setup 2FA'),
    });
  }

  confirmTotpEnable() {
    if (!this.totpUtente || !this.formTotpEnable.valid) return;
    this.apiService.enableTotpUtente(this.totpUtente.id, String(this.formTotpEnable.get('code')?.value)).subscribe({
      next: () => {
        this.totpUtente!.totp_enabled = 1;
        this.apiService.setUtenti();
        this.closeTotp();
        this.apiService.message('success', '2FA', 'Autenticazione a due fattori attivata');
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error?.message?.message || 'Codice non valido'),
    });
  }

  confirmTotpDisable() {
    if (!this.totpUtente) return;
    this.apiService.disableTotpUtente(this.totpUtente.id).subscribe({
      next: () => {
        this.totpUtente!.totp_enabled = 0;
        this.apiService.setUtenti();
        this.closeTotp();
        this.apiService.message('success', '2FA', 'Autenticazione a due fattori disattivata');
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error?.message?.message || 'Errore disattivazione'),
    });
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteUtente(event: Event, utente: Utente) {

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare l'utente? ${this.user?.id == utente?.id ? "Stai eliminando l'utente con cui sei loggato!" : ""}`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteUtente(utente.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {

            if (this.user?.id == utente?.id) {
              this.storageService.clearStorage()
              this.router.navigate(['/backoffice/login']);
            } else {
              this.router.navigate(['/backoffice/utenti']);
            }

            this.confirmationService.close()
            this.apiService.setUtenti()
            this.apiService.message("success", "Eliminazione", "L'utente è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeleteUtente() {
    this.deleteUtente.accept();
  }

  onAnnullaDeleteUtente() {
    this.deleteUtente.reject();
  }

}
